export const wrapWithAnchorTag = (homepage: string, title?: string) => {
  if (!homepage) return '';
  const anchorTagMatch = homepage.match(/<a[^>]*href=["']?([^"'\s>]+)["']?[^>]*>(.*?)<\/a>/i);
  if (anchorTagMatch) {
    return homepage;
  }

  const urlMatch = homepage.match(/(https?:\/\/[^\s]+)/);

  if (urlMatch) {
    const url = urlMatch[0];
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${title}</a>`;
  }

  return homepage;
};

export const removeEmptyValues = (data?: Object) => {
  return Object.fromEntries(
    Object.entries(data ?? {}).filter(
      ([key, value]) =>
        !['contentid', 'contenttypeid'].includes(key) &&
        value !== undefined &&
        value !== null &&
        value !== '' &&
        value !== '0',
    ),
  );
};

export const isHtml = (value?: string) => {
  return /<\/?[a-z][\s\S]*>/i.test(value ?? '');
};

export const formatDate = (value: string | Date | number, format: string = 'YYYY-MM-DD') => {
  let date: Date;

  if (value instanceof Date) {
    date = value;
  } else {
    const str = value.toString();

    if (/^\d{8}$/.test(str)) {
      const year = parseInt(str.substring(0, 4), 10);
      const month = parseInt(str.substring(4, 6), 10) - 1;
      const day = parseInt(str.substring(6, 8), 10);
      date = new Date(year, month, day);
    } else {
      date = new Date(str);
    }
  }

  if (isNaN(date.getTime())) {
    return value;
  }

  const year = date.getFullYear();
  const shortYear = year % 100;
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const paddedMonth = month.toString().padStart(2, '0');
  const paddedDay = day.toString().padStart(2, '0');
  const paddedYear = shortYear.toString().padStart(2, '0');

  return format
    .replace('YYYY', year.toString())
    .replace('YY', paddedYear)
    .replace('MM', paddedMonth)
    .replace('M', month.toString())
    .replace('DD', paddedDay)
    .replace('D', day.toString());
};

export const clearSession = () => {
  if (typeof window === 'undefined') return;

  const keys = ['lastPage', 'lastSearchKeyword', 'lastYear', 'lastSearchType', 'travelPage'];

  keys.forEach((key) => sessionStorage.removeItem(key));
};
